import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 90vw;
  min-height: 100vh;
  background: #fff;
  margin: 0 auto;
  flex-direction: column
  @media (max-width: 1024px){
    width: 100%;
    margin: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  min-height: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 0;
  box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.1);
  @media (max-width: 1024px){
    flex-direction: row;
    padding: 0;
  }
`;